import styled from '@emotion/styled';

const CustomInput = styled.input`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
  background: transparent;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  outline: none;
  transition: all 0.1s linear;
  width: ${(props) => (props.width ? props.width : '100%')};
  color: ${(props) => (props.color ? props.color : '#353535')};
  box-shadow: ${(props) => (props.shadow ? '0px -2px 10px rgba(0, 0, 0, 0.05);' : 'none')};
  &::placeholder {
    color: ${(props) => (props.disabledColor ? props.disabledColor : '#c9c9c9')};
    font-weight: 400;
  }
  &:disabled {
    opacity: 0.6;
    color: #616161;
    background-color: var(--surface-default);
    cursor: not-allowed;
  }
  &:focus {
    border: 1px solid #7f38e9;
  }
`;

export default CustomInput;
